<template>
  <main class="main page-inside products-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="back-title">{{ $t('Лавка BloxNest') }}</div>
            </div>
            <div class="tip">
              <div class="icon">
                <img src="./../img/gem.svg" class="icon-img" />
              </div>
              <div class="desc medium">
                {{ $t('Честная игра · только косметика, без преимуществ') }}
              </div>
            </div>
          </div>

          <div class="categories">
            <transition name="fade">
              <div class="list" v-if="$parent.categories">
                <!-- Add Packs tab first -->
                <div class="item">
                  <div class="item-wrapper">
                    <button
                      :class="['desc small', { active: showPacks }]"
                      @click="togglePacks"
                    >
                      <b>{{ $t('Packs') }}</b>
                    </button>
                  </div>
                </div>
                <div
                  class="item"
                  v-for="(item, i) in $parent.categories"
                  :key="i"
                >
                  <div class="item-wrapper">
                    <button
                      :class="[
                        'desc small',
                        {
                          active:
                            !showPacks && item.title == activeCategory.title,
                        },
                      ]"
                      @click="$emit('chooseCategoty', item)"
                    >
                      <b>{{ $t(item.title) }}</b>
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <div class="section products-section">
        <div class="wrapper">
          <div class="title title-main weight-600">
            {{ showPacks ? $t('Packs') : $t(activeCategory.title) }}
          </div>
          <transition name="fade">
            <div class="list products" v-if="products && !showPacks">
              <div class="item" v-for="(item, i) in products" :key="i">
                <ProductCard
                  :item="item"
                  :addToCartChosenItem="addToCartChosenItem"
                  @goToProduct="goToProduct"
                  :currency="currency"
                  @addToCart="addToCart"
                />
              </div>
            </div>
            <PacksList
              v-else-if="showPacks && packs.length"
              :packs="packs"
              :currency="currency"
              @addToCart="handlePackAddToCart"
            />
            <div v-else-if="showPacks" class="empty-state">
              <p>{{ $t('В данный момент наборы недоступны.') }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ProductCard from '../components/ProductCard.vue'
import PacksList from '../components/pack/PacksList.vue'
import useCurrency from '../utils/useCurrency'

export default {
  name: 'Products',
  props: ['addToCartChosenItem', 'activeCategory'],
  components: {
    ProductCard,
    PacksList,
  },
  emits: ['addToCart'],
  data: function () {
    return {
      products: [],
      packs: [],
      category: '',
      currency: '',
      showPacks: false,
    }
  },
  watch: {
    currency(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.showPacks) {
          this.getPacks()
        } else if (this.activeCategory && this.activeCategory.id) {
          this.getProducts()
        }
      }
    },
    activeCategory: {
      immediate: true,
      handler(newCategory) {
        if (newCategory && newCategory.id) {
          this.showPacks = false
          this.getProducts()
        }
      },
    },
    $route: {
      immediate: true,
      handler(to) {
        // Reset state when route changes
        if (to.path === '/products/packs') {
          this.showPacks = true
          this.getPacks()
        } else if (!to.path.includes('/packs')) {
          this.showPacks = false
          if (this.activeCategory && this.activeCategory.id) {
            this.getProducts()
          }
        }
      },
    },
  },
  mounted() {
    // Check if we're on the packs URL
    if (this.$route.path === '/products/packs') {
      this.showPacks = true
      this.getPacks()
    } else if (this.activeCategory && this.activeCategory.id) {
      this.getProducts()
    }

    // Sync currency from composable
    const currencyComposable = useCurrency()
    this.currency = currencyComposable.getCurrencyCode()
    currencyComposable.onCurrencyChange(() => {
      this.currency = currencyComposable.getCurrencyCode()
    })
  },
  methods: {
    handlePackAddToCart(item, id, type) {
      console.log('Products received addToCart:', item, id, type)

      this.$emit('addToCart', item, id, type)
    },
    getProducts() {
      if (!this.activeCategory || !this.activeCategory.id) {
        return
      }

      this.$http
        .get('products/?category_id=' + this.activeCategory.id)
        .then((res) => {
          this.products = res.data.payload
        })
        .catch(() => {})
    },
    getPacks() {
      this.$http
        .get('packs')
        .then((res) => {
          this.packs = res.data.payload
        })
        .catch(() => {})
    },
    togglePacks() {
      const newShowPacks = !this.showPacks
      this.showPacks = newShowPacks

      if (newShowPacks) {
        this.getPacks()
        if (this.$route.path !== '/products/packs') {
          this.$router.push({ path: '/products/packs' })
        }
      } else if (
        this.activeCategory &&
        this.activeCategory.id &&
        this.activeCategory.url
      ) {
        this.$router.push({ path: '/products' + this.activeCategory.url })
        this.getProducts() // Force products reload
      }
    },
    goToProduct(item) {
      this.$emit('goToProduct', item)
    },
    addToCart(item, id) {
      this.$emit('addToCart', item, id)
    },
    addPackToCart(packData) {
      this.$http
        .post('cart/add', {
          id: packData.packId,
          count: 1,
          type: 'pack',
        })
        .then((res) => {
          this.$emit('updateCart', res.data.cart)
          this.$parent.openCart()
        })
        .catch(() => {})
        .finally(() => {
          // Reset loading state
          const packIndex = this.packs.findIndex(
            (p) => p.id === packData.packId,
          )
          if (packIndex !== -1) {
            this.packs[packIndex].isLoading = false
          }
        })
    },
  },
}
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #6e7982;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
}
</style>
